import React from "react";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-forest text-white flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center space-y-4" data-testid="payment-cancel">
        <h1 className="font-display text-3xl">Trial cancelled</h1>
        <p className="text-white/70 text-sm">
          You closed the checkout without starting a trial. No card was charged.
        </p>
        <div className="flex gap-3 justify-center pt-2">
          <Link to="/pricing" className="btn-coral px-4 py-2 rounded-md text-sm font-medium">Back to pricing</Link>
          <Link to="/app" className="btn-outline-forest px-4 py-2 rounded-md text-sm font-medium">Keep using free plan</Link>
        </div>
      </div>
    </div>
  );
}
